import i18n from '@/i18n';

export class RuntimeError extends Error {
  public readonly i8n_name: string;

  public constructor(i8n_name: string, error_description?: string | null) {
    super(error_description || RuntimeError.getTranslatedMessage(i8n_name));
    this.i8n_name = i8n_name;
  }

  public getTranslatedTitle(): string {
    return RuntimeError.getTranslatedTitle(this.i8n_name);
  }

  public getTranslatedMessage(): string {
    return RuntimeError.getTranslatedMessage(this.i8n_name);
  }

  public static getTranslatedTitle(i8n_name: string): string {
    return i18n.global.t(i8n_name + '.title');
  }

  public static getTranslatedMessage(i8n_name: string): string {
    return i18n.global.t(i8n_name + '.message');
  }
}
